import { render, staticRenderFns } from "./HrAssetDiscountUpdate.vue?vue&type=template&id=3d7aa140&lang=pug&"
import script from "./HrAssetDiscountUpdate.vue?vue&type=script&lang=js&"
export * from "./HrAssetDiscountUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HrAssetDiscountUpdate.vue"
export default component.exports